import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import FooterPersonalizado from "components/FooterPersonalizado";

// Lazy loading de todas as páginas
const Homepage = lazy(() => import('./pages/homepage'));
const Solutions = lazy(() => import('./pages/solutions'));
const Contact = lazy(() => import('./pages/contact'));
const HostingPlans = lazy(() => import('./pages/hosting-plans'));
const CaseStudies = lazy(() => import('./pages/case-studies'));
const NotFound = lazy(() => import('pages/NotFound'));

// Componente de loading elegante
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen bg-gray-50">
    <div className="text-center">
      <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-primary mx-auto mb-4"></div>
      <p className="text-gray-600">Carregando...</p>
    </div>
  </div>
);

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Suspense fallback={<PageLoader />}>

          <RouterRoutes>
            {/* Define your route here */}
            <Route path="/" element={<Homepage />} />
            <Route path="/solucoes" element={<Solutions />} />
            <Route path="/contato" element={<Contact />} />
            <Route path="/hospedagem" element={<HostingPlans />} />
            <Route path="/resultados" element={<CaseStudies />} />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </Suspense>
        <FooterPersonalizado />
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;